import { useState, useEffect } from 'react';
import { ajaxor2, } from '../../common/basic';
import getNLS from '../../common/_NLS';



import TagItem from '../../common/items/TagItem';
import BrandItem from '../../common/items/BrandItem';
import LocationItem from '../../common/items/LocationItem';
import PersonInfoItem from '../../common/items/PersonInfoItem';

export default props => {

    const [vResultList, setResultList] = useState([,]);

    useEffect(() => {
        // console.log("vResultList: ", vResultList);
        if (props.keyword=='') return;
        ajaxor2({
            url: "/" + props.propertyType + "/search?query=" + props.keyword, // 1차만든거(갯수가하나만 나옴)
            // url: "/" + props.propertyType + "/searchWithGetPosts?query=" + props.keyword, // 0418 갯수로직 넣은거
            // callback: console.log,
            callback: setResultList,
        });

        return () => { ; }
    }, [props.propertyType, props.keyword]);

    // key = { v.nickname }
    // psaURL = { v.psaURL }
    // nickname = { v.nickname }
    // followerCount = { v.followerCount }
    // followingCount = { v.followingCount }
    // isFollowing = { v.isFollowing } 

    const jsx = (<div className="">
        <style jsx>{`

.item{
    height: 54px;
    font-size: 14px;
    color: #343a40;

    padding: 8px 10px;
}

.item.highlight{
    background-color: #55d5ce;
    opacity: 0.1;
}

.dib{
    margin: 0 10px;
}

div.line{
    height: initial;
    line-height: initial;
}

.line{
    text-align: left;
}

.l1{
    text-align: left;
}

.l2{
    font-size: 10px;
    color: #868e96;
}


div.right{
    float:right;
    padding-top: 5px;
}

.no-result{
    text-align: center;
    padding-top: 20px;
}

`}</style>

        <div className="results-container">

            {(!props.propertyType || !vResultList || vResultList.length > 0) ? '' :
                <div className="no-result">{getNLS("검색된 결과가 없습니다.")}</div>
            }

            {/* 해시태그 검색결과 */}
            {(props.propertyType == 'hashtag') ?
                <div>
                    {vResultList && vResultList.map(
                        (v, i, a) => (
                            <TagItem key={i} me={v} />
                        )
                    )}
                </div>
                : null}

            {/* 브랜드 검색결과 */}
            {(props.propertyType == 'brand') ?
                <div>
                    {vResultList && vResultList.map(
                        (v, i, a) => (
                            <BrandItem key={i} me={v} />
                        )
                    )}
                </div>
                : null}

            {/* 장소 검색결과 */}
            {(props.propertyType == 'location') ?
                <div>
                    {vResultList && vResultList.map(
                        (v, i, a) => (
                            <LocationItem key={i} me={v} />
                        )
                    )}
                </div>
                : null}


            {/* 사용자 검색결과 */}
            {(props.propertyType == 'user') ?
                <div>
                    {vResultList && vResultList.map(
                        (v, i, a) => (
                            <PersonInfoItem
                                key={i} me={v} 
                                // psaURL={v.psaURL}
                                // nickname={v.nickname}
                                // followerCount={v.followerCount}
                                // followingCount={v.followingCount}
                                // isFollowing={v.isFollowing}
                            />
                        )
                    )}
                </div>
                : null}
        </div>


    </div>);

    return (jsx);
};

                                // <TagItem key={i} itemName={v.itemName} count={v.count} />

                                // <PersonInfoItem 
                                //     key={v.nickname} 
                                //     psaURL={v.psaURL}
                                //     nickname={v.nickname} 
                                //     followerCount={v.followerCount} 
                                //     followingCount={v.followingCount} 
                                //     isFollowing={v.isFollowing} 
                                // />
